import { FormacionesDictadasContent } from "./comunidad/FormacionesDictadasContent";

export const FormacionesDictadasTab = () => {
  return <FormacionesDictadasContent />;
};
